import RoomsSelection from './RoomsSelection';

export default RoomsSelection;
